import React from 'react';
import PropTypes from 'prop-types';
import '../styles/components.css';
import { getStockStatus, formatStockMessage } from '../utils/stockUtils';

const StockIndicator = ({ stockLevel, etaValue = '' }) => {
    const stockStatus = getStockStatus(stockLevel, etaValue);
    const stockMessage = formatStockMessage(stockLevel, etaValue);

    return (
        <div className={`stock-indicator ${stockStatus}`}>
            {stockMessage}
        </div>
    );
};

StockIndicator.propTypes = {
    stockLevel: PropTypes.number.isRequired,
    etaValue: PropTypes.string,
};

export default StockIndicator;